<script setup lang="ts">
import type { MessageSchema } from '@/i18n';
import { useI18n } from 'vue-i18n';

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
</script>

<template>
  <div class="placeholder-image relative flex h-60 w-60 items-center justify-center rounded-3xl bg-primary-100">
    <div class="text-center">
      <div class="relative my-2 inline-block">
        <i class="pi pi-image text-primary-300" style="font-size: 4rem"></i>
        <div class="absolute -bottom-2 -right-3 flex aspect-square w-7 items-center justify-center rounded-full bg-accent text-white">
          <i class="pi pi-plus w-3 text-xs"></i>
        </div>
      </div>
      <div class="w-24 text-center font-bold text-primary-500">
        {{ t('planning.plannedMenu.uploadImage') }}
      </div>
      <!-- <div class="w-20 font-bold text-center text-primary-500">Add an image</div> -->
      <!-- <div class="w-20 font-bold text-center text-primary-500">Aggiungi un'immagine</div> -->
      <!-- <div class="w-20 font-bold text-center text-primary-500">Bild hinzufügen</div> -->
    </div>
  </div>
  <!-- <i class="pi pi-image text-primary-500" style="font-size: 0.5rem"></i>
  <button class="flex items-center justify-center w-10 p-2 text-white rounded-full bg-accent aspect-square">
    <i class="pi pi-plus" style="font-size: 1rem"></i>
  </button> -->
</template>
